import * as yup from 'yup';
export const CreateSubEntityFormValidation = yup.object().shape({
  description: yup.string().required("Campo é obrigatório"),
});
